import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { Bidder, BidderParams } from './types';

export const GET_BIDDER_LIST = 'bidders/GET_BIDDER_LIST';
export const GET_BIDDER_LIST_SUCCESS = 'bidders/GET_BIDDER_LIST_SUCCESS';
export const GET_BIDDER_LIST_ERROR = 'bidders/GET_BIDDER_LIST_ERROR';

export const UPDATE_BIDDER = 'bidders/UPDATE_BIDDER';
export const UPDATE_BIDDER_SUCCESS = 'bidders/UPDATE_BIDDER_SUCCESS';
export const UPDATE_BIDDER_ERROR = 'bidders/UPDATE_BIDDER_ERROR';

export const DELETE_BIDDER = 'bidders/DELETE_BIDDER';
export const DELETE_BIDDER_SUCCESS = 'bidders/DELETE_BIDDER_SUCCESS';
export const DELETE_BIDDER_ERROR = 'bidders/DELETE_BIDDER_ERROR';

export const GET_BIDDER_DETAIL = 'bidders/GET_BIDDER_DETAIL';
export const GET_BIDDER_DETAIL_SUCCESS = 'bidders/GET_BIDDER_DETAIL_SUCCESS';
export const GET_BIDDER_DETAIL_ERROR = 'bidders/GET_BIDDER_DETAIL_ERROR';

export const getBidderListAsync = createAsyncAction(
  GET_BIDDER_LIST,
  GET_BIDDER_LIST_SUCCESS,
  GET_BIDDER_LIST_ERROR,
)<BidderParams, Bidder[], AxiosError>();

export const updateBidderAsync = createAsyncAction(
  UPDATE_BIDDER,
  UPDATE_BIDDER_SUCCESS,
  UPDATE_BIDDER_ERROR,
)<BidderParams, Bidder, AxiosError>();

export const deleteBidderAsync = createAsyncAction(
  DELETE_BIDDER,
  DELETE_BIDDER_SUCCESS,
  DELETE_BIDDER_ERROR,
)<BidderParams, number, AxiosError>();

export const getBidderDetailAsync = createAsyncAction(
  GET_BIDDER_DETAIL,
  GET_BIDDER_DETAIL_SUCCESS,
  GET_BIDDER_DETAIL_ERROR,
)<BidderParams, Bidder, AxiosError>();
